import React, { useState } from 'react';
import './Instrument.css';

function DrumsInstrument({ onAddNote }) {
  const [selectedDrum, setSelectedDrum] = useState(null);

  // 架子鼓：标准架子鼓配置 (meow: 20-29, song: 十进制25-34)
  const drumPads = [
    { name: '大鼓/BD', song: '19', meow: '1', color: '#d35400', position: 'bottom' },        // 25 (0x19)
    { name: '通鼓0/T0', song: '1A', meow: '2', color: '#e67e22', position: 'top' },         // 26 (0x1A)
    { name: '通鼓1/T1', song: '1B', meow: '3', color: '#e67e22', position: 'top' },         // 27 (0x1B)
    { name: '通鼓2/T2', song: '1C', meow: '4', color: '#e67e22', position: 'top' },         // 28 (0x1C)
    { name: '通鼓3/T3', song: '1D', meow: '5', color: '#e67e22', position: 'top' },         // 29 (0x1D)
    { name: '军鼓/SD', song: '1E', meow: '6', color: '#c0392b', position: 'center' },       // 30 (0x1E)
    { name: '吊镲1/C1', song: '1F', meow: '7', color: '#f1c40f', position: 'top-right' },   // 31 (0x1F)
    { name: '吊镲2/C2', song: '20', meow: '8', color: '#f1c40f', position: 'top-right' },   // 32 (0x20)
    { name: '吊叮镲/Ri', song: '21', meow: '1', color: '#f39c12', position: 'right' },      // 33 (0x21)
    { name: '踩镲/HH', song: '22', meow: '2', color: '#f39c12', position: 'top-left' },     // 34 (0x22)
  ];

  const handleDrumClick = (drum) => {
    setSelectedDrum(drum);
    // 确保 meow 值是两位16进制格式（带前导0）
    let meowHex = String(drum.meow);
    if (meowHex.length === 1) {
      meowHex = `0${meowHex}`;
    }
    onAddNote(meowHex.toUpperCase(), drum.song);
  };

  return (
    <div className="instrument">
      <div className="instrument-title">
        <span className="icon">🥁</span>
        <div>
          <h3>架子鼓</h3>
          <p className="subtitle">标准架子鼓配置</p>
        </div>
      </div>

      <div className="drums-container">
        <div className="drums-visual">
          {/* 鼓组可视化布局 */}
          <div className="drum-layout">
            {drumPads.map((drum, index) => (
              <button
                key={index}
                className={`drum-pad ${selectedDrum?.name === drum.name ? 'selected' : ''}`}
                style={{ 
                  background: `linear-gradient(135deg, ${drum.color}, ${drum.color}dd)`,
                }}
                onClick={() => handleDrumClick(drum)}
              >
                <div className="drum-name">{drum.name}</div>
                <div className="drum-hex">0x{drum.song}</div>
              </button>
            ))}
          </div>
        </div>

        {/* 鼓垫列表视图 */}
        <div className="drums-list">
          {drumPads.map((drum, index) => (
            <button
              key={index}
              className={`drum-btn ${selectedDrum?.name === drum.name ? 'selected' : ''}`}
              style={{ 
                borderLeft: `4px solid ${drum.color}`,
              }}
              onClick={() => handleDrumClick(drum)}
            >
              <span className="drum-label">{drum.name}</span>
              <span className="drum-value">0x{drum.song}</span>
            </button>
          ))}
        </div>
      </div>

      <div className="help-text">
        <p>💡 点击鼓垫添加到乐谱</p>
      </div>
    </div>
  );
}

export default DrumsInstrument;

